import {DoorElevationDetail} from "./PurchaseOrderPDF";
import {PDFHeader} from "../../../../misc/pdf/parts/PDFHeader";
import {Page} from "../../../../misc/pdf/parts/Page";
import {grey} from "@mui/material/colors";

export function DoorElevationDetails(props: {
    value: DoorElevationDetail[];
}) {

    return (
        <>
            {props.value.map((d, index) => (
                <Page orientation="landscape" key={"elev-" + index}>
                    <div style={{flex: 1, display: "flex", flexDirection: "column", alignItems: "stretch"}}>
                        <PDFHeader noAddress title={"Door Elevation " + d.elevation} />
                        <div style={{flex: 1, display: "flex", flexDirection: "row", alignItems: "stretch"}}>
                            <div style={{
                                flex: 1,
                                border: "1px solid " + grey["200"],
                                paddingLeft: 4,
                                paddingRight: 4,
                                backgroundImage: d.elevationFileContent ? "url(" + d.elevationFileContent + ")" : "none",
                                backgroundSize: "contain",
                                backgroundPosition: "center center",
                                backgroundRepeat: "no-repeat",
                            }}/>
                            <div style={{
                                flex: 1,
                                border: "1px solid " + grey["200"],
                                paddingLeft: 4,
                                paddingRight: 4,
                                backgroundImage: d.profileContent ? "url(" + d.profileContent + ")" : "none",
                                backgroundSize: "contain",
                                backgroundPosition: "center center",
                                backgroundRepeat: "no-repeat",
                            }}/>
                        </div>
                    </div>
                </Page>
            ))}
        </>
    )
}